import { Directive, ElementRef, HostListener, NgZone, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
@Directive({
  selector: '[appVisibility]'
})
export class VisibilityDirective implements OnInit,OnDestroy {
  private animation: gsap.core.Tween | null = null;
  private scrollTrigger?: ScrollTrigger;
  private gsapCtx: any;

  constructor(
    private el: ElementRef,
    private zone: NgZone
  ) {
    gsap.registerPlugin(ScrollTrigger);
  }

  ngOnInit() {
    this.zone.runOutsideAngular(() => {
      // use gsap.context to scope selectors and make cleanup easier
      try {
        this.gsapCtx = gsap.context(() => {
          // Initial setup
          gsap.set(this.el.nativeElement, {
            willChange: 'transform, opacity',
            backfaceVisibility: 'hidden'
          });

          // Create the animation
          this.animation = gsap.from(this.el.nativeElement, {
            y: '30vh', // Start further down for more dramatic effect
            opacity: 0,
            duration: 1.2,
            ease: "expo.out",
            immediateRender: false,
            overwrite: 'auto',
            scrollTrigger: {
              trigger: this.el.nativeElement,
              start: "top bottom-=10%",
              end: "top 30%",
              scrub: 0.8,
              markers: false,
              anticipatePin: 1,
              onEnter: () => this.animation?.play(),
              onLeaveBack: () => this.animation?.progress(0).pause(),
              onUpdate: self => {
                const velocity = Math.abs(self.getVelocity());
                if (this.animation) gsap.to(this.animation, { timeScale: Math.min(1, velocity / 100) });
              }
            }
          });

          this.scrollTrigger = this.animation?.scrollTrigger;
        }, this.el.nativeElement);
      } catch (e) {
        // fallback: create animation without context
        gsap.set(this.el.nativeElement, {
          willChange: 'transform, opacity',
          backfaceVisibility: 'hidden'
        });
        this.animation = gsap.from(this.el.nativeElement, {
          y: '30vh', opacity: 0, duration: 1.2, ease: 'expo.out', immediateRender: false, overwrite: 'auto'
        });
      }
    });
  }

  ngOnDestroy() {
    try {
      if (this.scrollTrigger) {
        this.scrollTrigger.kill();
      }
    } catch (e) {}
    try {
      if (this.animation) {
        this.animation.kill();
      }
    } catch (e) {}
    try {
      if (this.gsapCtx && typeof this.gsapCtx.revert === 'function') this.gsapCtx.revert();
    } catch (e) {}
  }
}